import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M14.3 18.959a.75.75 0 0 1 .75.75v2.314a.75.75 0 1 1-1.5 0v-2.314a.75.75 0 0 1 .75-.75m-6.5 3.269a.75.75 0 1 1-1.4-.538zm8.809-12.993a.75.75 0 0 1 .969.431L22.2 21.69a.75.75 0 0 1-.431.969.75.75 0 0 1-.969-.431l-4.622-12.023a.75.75 0 0 1 .431-.97"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.022 9.666a.75.75 0 1 1 1.4.539L7.8 22.228l-.7-.27-.7-.269zm3.278 4.208a.75.75 0 0 1 .75.75v2.322l-.004.076a.75.75 0 0 1-1.492 0l-.004-.076v-2.322a.75.75 0 0 1 .75-.75"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.53 7.513a5.55 5.55 0 0 1 6.225-4.787 5.6 5.6 0 0 1 1.59.454.75.75 0 0 1-.027 1.376c-.866.355-1.505.791-1.956 1.34s-.752 1.249-.877 2.205c-.233 1.789.599 3.037 1.892 4.338a.75.75 0 0 1-.405 1.268 5.553 5.553 0 0 1-6.44-6.194zm5.452-3.334a4.053 4.053 0 0 0-.809 8.011c-.844-1.146-1.408-2.512-1.177-4.284.155-1.186.551-2.166 1.206-2.963a5.3 5.3 0 0 1 .779-.765z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3 9.46a.75.75 0 0 1 .75.75v1.613a.75.75 0 1 1-1.5 0V10.21a.75.75 0 0 1 .75-.75"
}));
const ForwardRef = forwardRef(SvgComponent);
export const MoonRoadIcon = ForwardRef;